<template>
    <div class="quote author">
        <p><slot></slot></p>
    </div>
</template>

<style lang="scss" scoped>
    // see /static/scss/components/_citaat.scss
</style>

<script>
    export default {

    };
</script>
